@if (hasDataRows$ | async) {
  <nk-card-content type="table">
    <p class="text-uppercase font-weight-bold mb-0">
      {{ 'collateral_card.chart_title' | translate }}
    </p>

    @if (chartOptions$ | async; as chartOptionsBars) {
      <highcharts-chart
        class="d-block w-100"
        [class.faded-3]="loadingChart()"
        [Highcharts]="highcharts"
        [oneToOne]="true"
        [options]="chartOptionsBars"
        [style]="{ height: '250px' }">
      </highcharts-chart>
    }
    <nk-progress class="d-block mb-1" [isLoading]="loading() || loadingChart()"></nk-progress>
    <!-- If we show legend (list of creditors) we need more height space-->

    @if (relevantCollateralTypes$ | async; as relevantCollateralTypes) {
      <div [class.faded-3]="loading()">
        @if (relevantCollateralTypes.length > 1) {
          @for (type of relevantCollateralTypes; track type.uuid) {
            <button
              nkButton
              size="xs"
              andClass="mb-2"
              (click)="setCollateralType(type.uuid)"
              [color]="type.uuid === selectedCollateralType() ? 'primary' : 'secondary'">
              {{ 'collateral_type_key.' + type.collateral_type_key | translate }}
            </button>
          }
        }
      </div>
    }
  </nk-card-content>
}
